import * as React from 'react';
export const MUSvg = React.forwardRef(function MUSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M1.994 2h12.012C15.106 2 16 2.896 16 4.001V5H0v-.999A2 2 0 0 1 1.994 2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M0 8h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M0 5h16v3H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        fillOpacity: 0.1,
        fillRule: 'nonzero',
        d: 'M15 11V8h1v3h-1ZM0 8h1v3H0V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#24B47E',
        d: 'M0 11h16v1c0 1.112-.893 2-1.994 2H1.994C.894 14 0 13.105 0 12v-1Z',
      }),
    ),
  );
});
MUSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var MU = {
  category: 'flag',
  colorable: false,
  name: 'MU',
  svg: MUSvg,
};
